<template lang="pug">
    div
        crud-form(:fields="fields" noButtons)
            template(slot="appendContent")
                v-layout(wrap)
                    //- v-flex.xs12.md6
                    //- v-flex.xs12.md6
                    //-     input-button.pl-5.pr-3.block-field(
                    //-         :btnText="btnText"
                    //-         :btnIcon="btnIcon"
                    //-         :inputProps="{readonly: true}"
                    //-         @button:click="toggleLock()"
                    //-         :value="inputString"
                    //-         :loading="loading"
                    //-     )
                    v-flex.xs12.md6
                    v-flex.xs12.md6
                        v-btn.btn_position(:color="btnColor" dark @click="toggleLock") {{btnText}}
                            v-icon(dark right) {{btnIcon}}
</template>

<script>
/* components */
import { CrudForm, InputButton } from '@/components/reusable_components'
import fields from './fields/CommercialInfoFields.js'
/* services */
import CustomerService from '@/services/api/customer'
/* vuex */
import { mapActions } from 'vuex'
/* mixins */
import snackbarModalUtils from '../../../mixins/reusable_mixins/SnackbarModalUtils'
export default {
    name: 'commercial-info',
    props: {},
    data: function() {
        return {
            fields: fields,
            data: {},
            blocked: false,
            loading: false,
        }
    },
    computed: {
        btnIcon() {
            return this.blocked ? 'lock_open' : 'lock_outline'
        },
        btnText() {
            return this.blocked ? 'desbloquear' : 'bloquear'
        },
        inputString() {
            return this.blocked ? 'bloqueado' : 'desbloqueado'
        },
        btnColor(){
            return this.blocked ?  'success' : 'red' 
        }
    },
    methods: {
        async getCustomerData() {
            let customer = await CustomerService.findById(this.$route.params.id)
            let fields = [...this.fields]
            this.data = customer
            const fullname = employee => {
                return employee.names + ' ' + employee.last_name1
            }
            
            fields[0].value = customer.discount
            fields[1].value = (customer.sl_ground_seller[0]) ? fullname(customer.sl_ground_seller[0].hr_employee) : "Sin vendedor"
            fields[2].value = customer.pch_payment_condition.type
            fields[3].value = ( customer.blocked_sales === true ) ? "Bloqueado" : "Desbloqueado"
            this.blocked = this.data.blocked_sales
            this.fields = [...fields]
        },
        async toggleLock() {
            let data = { ...this.data }
            let payload = this.getPayloadForBlockUnblockCustomer()
        
            this.loading = true
            let response = await CustomerService.blockUnblockCustomer(payload)
            this.snackResponseSubmit(response,'Cliente actualizado correctamente')
            if (response.status === 200){
                this.$router.go()
            }
            //this.data = response
        },
        /**
         */
        getPayloadForBlockUnblockCustomer(){
            let dataForm = { ...this.data }
            let payload = {}
            payload.sl_customer_id = dataForm.id
            payload.blocked_sales = !this.blocked
            return payload
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
        }),
    },
    watch: {},
    components: {
        'crud-form': CrudForm,
        'input-button': InputButton,
    },
    mixins: [snackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: async function() {
    //     await this.getCustomerData()
    // },
    // beforeMount: function(){...},
    mounted: async function(){
        await this.getCustomerData()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.block-field {
    margin-top: -84px;
}
.btn_position{
    margin-left:75%;
}
</style>